// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { Col, Row } from "react-grid-system";
import { STable } from "../../styles/AdminSearchScore";
import EditIcon from "../../assets/img/icons/edit-black.svg";
import { useState } from "react";
import { StyledModal } from "../../styles/StyledModal";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import ReactModal from "react-modal";
import { ChangeUserPassword } from "../Admin";
import { EditUser } from "../Admin/EditUser";
import { UserActivation } from "../Admin/UserActivation";
import { UserType } from "../../api/admin/user";
import { Role, userRoleLabels } from "../../constants/role";
import useCurrentUser from "../../hooks/useCurrentUser";

type UsersListProps = {
	refetchUsers: () => void;
	users: UserType[] | undefined;
};

type ModalType = "EDIT" | "PASSWORD" | "ACTIVATION";

export const UsersList = (props: UsersListProps) => {
	const { refetchUsers, users } = props;
	const { user: currentUser, isOrgAdmin } = useCurrentUser();
	const [userId, setUserId] = useState<number | undefined>(undefined);
	const [modalType, setModalType] = useState<ModalType | undefined>(undefined);

	const open = (type: ModalType, id: number) => {
		setUserId(id);
		setModalType(type);
	};

	const handleClose = () => {
		setUserId(undefined);
		setModalType(undefined);
	};

	const mapped = users?.map((user) => (
		<tr key={user.id}>
			<td colSpan={2}>
				{user.firstName} {user.lastName}
				<br />
				<small>{user.username}</small>
			</td>
			<td colSpan={2} style={{ overflowWrap: "anywhere" }}>
				{user.email}
			</td>
			<td>{user.roles.map((role) => userRoleLabels.find((r) => r.value === role)?.label).filter(Boolean).join(", ")}</td>
			<td colSpan={2}>
				{(user.organizationUnits ?? [])
					.map(({ organizationUnit, roles }) => `${organizationUnit.name}${roles.includes(Role.admin) ? " (unit admin)" : ""}`)
					.join(", ") || "-"}
			</td>
			<td>{user.active ? "Active" : "Inactive"}</td>
			<td>
				{isOrgAdmin && (
					<>
						<button onClick={() => open("EDIT", user.id)} title="Edit user">
							<img src={EditIcon} alt="Edit" />
						</button>
						<button onClick={() => open("PASSWORD", user.id)}>Password</button>
						{user.id !== currentUser?.id && (
							<button onClick={() => open("ACTIVATION", user.id)}>{user.active ? "Deactivate" : "Reactivate"}</button>
						)}
					</>
				)}
			</td>
		</tr>
	));

	return (
		<>
			<Row>
				<Col>
					<STable>
						<thead>
							<tr>
								<td colSpan={2}>Name</td>
								<td colSpan={2}>Email</td>
								<td>Role</td>
								<td colSpan={2}>Units</td>
								<td>Status</td>
								<td>Actions</td>
							</tr>
						</thead>
						<tbody>
							{mapped?.length === 0 ? (
								<tr>
									<td colSpan={10}>No users found</td>
								</tr>
							) : (
								mapped
							)}
						</tbody>
					</STable>
				</Col>
			</Row>
			<ReactModal isOpen={modalType !== undefined} onRequestClose={handleClose} style={StyledModal} ariaHideApp={false}>
				{modalType === "EDIT" && userId !== undefined ? (
					<EditUser userId={userId} refetchUsers={refetchUsers} closeModal={handleClose} />
				) : null}
				{modalType === "PASSWORD" && userId !== undefined ? <ChangeUserPassword userId={userId} closeModal={handleClose} /> : null}
				{modalType === "ACTIVATION" && userId !== undefined ? (
					<UserActivation userId={userId} refetchUsers={refetchUsers} closeModal={handleClose} />
				) : null}
			</ReactModal>
		</>
	);
};
